<template>
  <tr class="html-email-template-row">
    <td>{{ template.name }}</td>
    <td>{{ template.pre_header }}</td>
    <td class="text-right">
      <a-tooltip placement="left">
        <template slot="title">
          <span>Template bekijken</span>
        </template>
        <a-button type="secondary" v-on:click.stop="onShowClick()">
          <eye-icon></eye-icon>
        </a-button>
      </a-tooltip>
      <a-tooltip v-if="canEdit" placement="left">
        <template slot="title">
          <span>Template bewerken</span>
        </template>
        <a-button type="primary" v-on:click.stop="onEditClick()">
          <pencil-icon></pencil-icon>
        </a-button>
      </a-tooltip>
      <a-popconfirm cancel-text="Nee" ok-text="Ja" placement="topRight"
                    @confirm="onDeleteClick()">
        <template slot="title">
          <span>Template verwijderen</span>
        </template>
        <a-button type="danger">
          <delete-icon></delete-icon>
        </a-button>
      </a-popconfirm>
    </td>

    <a-modal class="show-html-email-template-content-modal" width="60%" :title="'Template - ' + this.template.name" v-model="showModal">
      <template>
        <h5>Preheader: {{ template.pre_header }}</h5>
        <br/>
            <HtmlEmailTemplateExample :template-content="template.content"/>

      </template>
      <template slot="footer">

        <a-button key="back" @click="closeModal" type="default">
          Sluiten
        </a-button>
      </template>
    </a-modal>

  </tr>
</template>
<script>
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles
import {Prism} from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import HtmlEmailTemplateExample from './ExampleComponent'
import htmlEmailTemplateApi from '~/api/html_email_template'

export default {
  name: 'HtmlEmailTemplateRowComponent',
  components: { HtmlEmailTemplateExample, Prism },
  props: {
    template: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {},
  methods: {
    onEditClick() {
      window.location.href = '/settings/html_email_template/' + this.template.id + '/edit';
    },
    onShowClick() {
      this.showModal = true
    },
    onDeleteClick() {
      htmlEmailTemplateApi.delete(this.template.id).then( () => {
        this.$emit('reload-templates')
      })
    },
    closeModal() {
      this.showModal = false
    },
  },
};
</script>

<style scoped>
.btn-warning {
  color: #fff;
  background-color: #b2c740;
  border-color: #a3b836;
}
</style>
